/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTypesControllerCreateMutationRequest, ProjectTypesControllerCreateMutationResponse, ProjectTypesControllerCreate400, ProjectTypesControllerCreate401, ProjectTypesControllerCreate403 } from "../../models/projectTypesController/ProjectTypesControllerCreate";

function getProjectTypesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/project-types` as const }  
  return res
}

/**
 * @summary Create a new project type
 * {@link /api/v1/project-types}
 */
export async function projectTypesControllerCreate(data?: ProjectTypesControllerCreateMutationRequest, config: Partial<RequestConfig<ProjectTypesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectTypesControllerCreateMutationResponse, ResponseErrorConfig<ProjectTypesControllerCreate400 | ProjectTypesControllerCreate401 | ProjectTypesControllerCreate403>, ProjectTypesControllerCreateMutationRequest>({ method : "POST", url : getProjectTypesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}